<!-- app-subdomain-creators/src/Components/CreatorChatSearchShowAllFiles.vue -->
<template>
  <div>
    <!-- Loop through the grouped files -->
    <div
      v-for="(filesForMonth, month) in groupedFiles"
      :key="month"
      class="mb-8"
    >
      <div class="flex justify-between items-center mb-5">
        <h4 class="text-zinc-500 text-sm font-semibold">{{ month }}</h4>

        <!-- back to menu -->
        <div @click="toggleBackToFiles" class="flex gap-1 cursor-pointer">
          <ArrowLeftIcon class="w-4 text-[#2D8CFF]" />
          <div class="text-[#2D8CFF] text-sm font-semibold">
            Back to all Files
          </div>
        </div>
      </div>

      <div class="w-full space-y-2">
        <div
          v-for="(file, index) in filesForMonth"
          :key="`${month}-${file.messageId || 'f'}-${file.attachmentIndex || index}`"
        >
          <CreatorChatFilePreview
            :url="file.url"
            :title="file.title"
            :created-at="file.createdAt"
            :sender-type="file.senderType"
            :creator-avatar-src="creatorAvatarSrc"
            :member-avatar-src="memberAvatarSrc"
            :mime="file.mime"
            :size-bytes="file.sizeBytes"
            @open-file="(payload) => handleFileClick(file, payload)"
          />


        </div>
      </div>
    </div>

    <!-- Load more files (paging) -->
    <div v-if="hasMore" class="mt-4 flex justify-center">
      <button
        type="button"
        class="px-3 py-1.5 text-xs font-medium rounded-full bg-zinc-100 text-zinc-600 hover:bg-zinc-200 disabled:opacity-50"
        :disabled="isLoadingMore"
        @click="onLoadMoreClicked"
      >
        <span v-if="!isLoadingMore">Load older files</span>
        <span v-else>Loading…</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import CreatorChatFilePreview from '@/Components/CreatorChatFilePreview.vue';

const props = defineProps({
  searchFiles: {
    type: Array,
    default: () => [],
  },
  creatorAvatarSrc: {
    type: String,
    default: '',
  },
  memberAvatarSrc: {
    type: String,
    default: '',
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoadingMore: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['toggleShowAllFiles', 'loadMoreFiles', 'open-file']);


const toggleBackToFiles = () => {
  emits('toggleShowAllFiles');
};

const onLoadMoreClicked = () => {
  emits('loadMoreFiles');
};

// Grouping Files by month (based on createdAt)
const groupedFiles = computed(() => {
  const filesByMonth = {};
  (props.searchFiles || []).forEach((file) => {
    const raw = file.createdAt || file.date;
    if (!raw) return;
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return;

    const monthYear = d.toLocaleString('default', {
      month: 'long',
      year: 'numeric',
    });

    if (!filesByMonth[monthYear]) {
      filesByMonth[monthYear] = [];
    }
    filesByMonth[monthYear].push(file);
  });
  return filesByMonth;
});

const handleFileClick = (file, payload) => {
  if (!payload || !payload.src) return;
  emits('open-file', payload);
};



</script>

